// extracted by mini-css-extract-plugin
module.exports = {"margin":"TopPicks_margin__XaHQq","headerBox":"TopPicks_headerBox__OeTiY","seeAll":"TopPicks_seeAll___hl7z","header":"TopPicks_header__6_qgw","Link":"TopPicks_Link__8DuGp"};